import script from "./My.vue?vue&type=script&setup=true&lang=js"
export * from "./My.vue?vue&type=script&setup=true&lang=js"

import "./My.vue?vue&type=style&index=0&id=1aad51a4&lang=scss&scoped=true"

import exportComponent from "/home/ecs-user/software/jenkins/workspace/smallshop-website-uat/smallshop-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aad51a4"]])

export default __exports__